import { shapes } from '@joint/plus';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';

import Input from '../Input/Input';
import { useBaseInspector } from './useBaseInspector';
import SmartAutocomplete from '../Input/SmartAutocomplete/SmartAutocomplete';
import { getChannelList, getTecnicalsByChannel } from 'src/services/2talk/channel';

interface Props {
  cell: shapes.app.TalkAttendant;
}

const cellProps = {
  label: ['attrs', 'label', 'text'],
  channelId: ['attrs', 'channelId', 'id'],
  channelTecnicalId: ['attrs', 'channelTecnicalId', 'id'],
};

const TalkAttendantInspector = (props: Props): ReactElement => {

    const { cell } = props;

    const [label, setLabel] = useState<string>(cell.prop(cellProps.label));

    const [channelId, setChannelId] = useState(null);
    const [channelOptions, setChannelOptions] = useState([]);

    const [channelTecnicalId, setChannelTecnicalId] = useState(null);
    const [channelTecnicalOptions, setChannelTecnicalOptions] = useState([]);

    const assignFormFields = useCallback((): void => {
        setLabel(cell.prop(cellProps.label));
        setChannelId(cell.prop(cellProps.channelId));
        setChannelTecnicalId(cell.prop(cellProps.channelTecnicalId));
    }, [cell]);

    const changeCellProp = useBaseInspector({ cell, assignFormFields });

    const fetchChannels = async () => {
        const response = await getChannelList() as any;

        if (response?.success === true && response?.data?.length > 0) {
            setChannelOptions(response.data);
        }
    }

    const fetchChannelTecnicals = async () => {
        const response = await getTecnicalsByChannel(channelId) as any;

        if (response?.success === true && response?.data?.length > 0) {
            setChannelTecnicalOptions(response.data);
        }
    }

    useEffect(() => {
        fetchChannels();
    }, []);

    useEffect(() => {
        if (channelId) {
            fetchChannelTecnicals();
        } else {
            setChannelTecnicalOptions([]);
        }    
    }, [channelId]);

    return (
        <>

            <label>Label
                <Input 
                    type="text"
                    placeholder="Enter label"
                    value={label}
                    disabled={true}
                />
            </label>   

            <label>Canais
                <SmartAutocomplete 
                    value={channelId}
                    options={channelOptions}
                    onChange={(e) => changeCellProp(cellProps.channelId, e.target.value)}
                />
            </label>

            <label>Agentes
                <SmartAutocomplete 
                    value={channelTecnicalId}
                    options={channelTecnicalOptions}
                    onChange={(e) => changeCellProp(cellProps.channelTecnicalId, e.target.value)}
                />
            </label>

        </>
    );
};

export default TalkAttendantInspector;
